/**
 * After opening a modal from `mouseup` (e.g. Gantt bar drag-end), the browser still
 * dispatches a `click` on the element under the cursor. If React has already mounted a
 * full-screen backdrop, that click hits the overlay and looks like an intentional dismiss.
 *
 * Prefer arming dismiss on overlay `mousedown` (see `shouldDismissModalOverlay`) so a
 * trailing click whose mousedown landed on the gantt never cancels. Keep a short
 * post-mount time guard as a second line of defense (CRM #21 / #35 + edge auto-pan).
 */
export const MODAL_GHOST_CLICK_GUARD_MS = 600;

export function isModalGhostClick(openedAtMs: number, nowMs: number = Date.now()): boolean {
  return nowMs - openedAtMs < MODAL_GHOST_CLICK_GUARD_MS;
}

/**
 * True when the backdrop should dismiss: the pointer pressed on the overlay itself
 * (not a ghost click that only `click`s the overlay after a gantt `mouseup`).
 */
export function shouldDismissModalOverlay(opts: {
  openedAtMs: number;
  overlayMouseDownArmed: boolean;
  nowMs?: number;
}): boolean {
  if (!opts.overlayMouseDownArmed) return false;
  if (isModalGhostClick(opts.openedAtMs, opts.nowMs)) return false;
  return true;
}
